import { useState } from "react";
import { api } from "@/api";
import { toast } from "@/lib/toast";
import { AccountSelect, Btn, Field, Modal, errMsg, inputCls, money } from "../../comptabilite/_shared";
import { PartySelect, TaxCodeSelect, useParties } from "../_books";
import { taxPreview } from "./QuickEntryDialog";

export default function DocumentDialog({ base, line, accounts, settings, onClose, onDone }) {
  const out = line.amount < 0;
  const partyKind = out ? "supplier" : "customer";
  const { parties } = useParties(partyKind);
  const [form, setForm] = useState({ party_id: "", new_party_name: "", account_id: line.suggested_account_id || "", tax_code: "T", description: line.description, number: line.ref || "" });
  const [newParty, setNewParty] = useState(false);
  const [busy, setBusy] = useState(false);
  const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));
  const tx = taxPreview(line.amount, form.tax_code, settings);
  const cabinetCustomer = !out && base === "/gl";

  const save = async () => {
    if (!form.account_id) return toast.error(out ? "Choisissez le compte de dépense" : "Choisissez le compte de revenu");
    if (!form.party_id && !(newParty && form.new_party_name.trim())) return toast.error(out ? "Choisissez un fournisseur" : "Choisissez un client");
    setBusy(true);
    try {
      await api.post(`${base}/bank/lines/${line.id}/document`, { ...form, party_id: newParty ? null : form.party_id, new_party_name: newParty ? form.new_party_name.trim() : null });
      toast.success(out ? "Achat et paiement créés, ligne conciliée" : "Vente et encaissement créés, ligne conciliée"); onDone();
    } catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };

  return (
    <Modal title={out ? "Créer un achat payé par ce retrait" : "Créer une vente encaissée par ce dépôt"} sub={`${line.date} · ${line.description} · ${money(line.amount)} — la pièce et son paiement sont créés et reportés, puis la ligne est conciliée.`} onClose={onClose} testId="bank-doc-dialog"
      footer={<><Btn tone="slate" onClick={onClose} testId="bank-doc-cancel">Annuler</Btn><Btn onClick={save} busy={busy} testId="bank-doc-save">{out ? "Créer l'achat" : "Créer la vente"}</Btn></>}>
      <Field label={out ? "Fournisseur" : "Client"}>
        {!newParty ? <PartySelect kind={partyKind} parties={parties} value={form.party_id} onChange={(v) => set("party_id", v)} testId="bank-doc-party" />
          : <input value={form.new_party_name} onChange={(e) => set("new_party_name", e.target.value)} placeholder={out ? "Nom du nouveau fournisseur" : "Nom du nouveau client"} className={inputCls} data-testid="bank-doc-new-party" autoFocus />}
        {!cabinetCustomer && <button type="button" onClick={() => setNewParty((v) => !v)} className="text-[11px] text-teal-700 hover:underline mt-1" data-testid="bank-doc-toggle-new-party">{newParty ? "Choisir un tiers existant" : `+ Nouveau ${out ? "fournisseur" : "client"}`}</button>}
      </Field>
      <Field label={out ? "Compte de dépense" : "Compte de revenu"}>
        <AccountSelect accounts={accounts} value={form.account_id} onChange={(v) => set("account_id", v)} types={out ? ["expense", "asset", "liability"] : ["revenue", "liability"]} testId="bank-doc-account" />
      </Field>
      <div className="grid sm:grid-cols-3 gap-3">
        <Field label="Taxes incluses"><TaxCodeSelect value={form.tax_code} onChange={(v) => set("tax_code", v)} testId="bank-doc-tax" /></Field>
        <Field label={out ? "N° facture fournisseur" : "N° (vide = auto)"}><input value={form.number} onChange={(e) => set("number", e.target.value)} className={inputCls} data-testid="bank-doc-number" /></Field>
        <Field label="Description"><input value={form.description} onChange={(e) => set("description", e.target.value)} className={inputCls} data-testid="bank-doc-desc" /></Field>
      </div>
      <div className="text-xs text-slate-600 bg-slate-50 border rounded-lg px-3 py-2 font-mono" data-testid="bank-doc-preview">
        Sous-total {money(tx.net)}{tx.tps ? ` + TPS ${money(tx.tps)}` : ""}{tx.tvq ? ` + TVQ ${money(tx.tvq)}` : ""} = {money(Math.abs(line.amount))}
      </div>
    </Modal>
  );
}
